<div class="compare-formula-bar">
  <div class="formula-bar-inputs">
    <form nz-form [formGroup]="validateForm" (ngSubmit)="submitForm()">
      <nz-form-item>
        <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired nzFor="dp"
          >DP</nz-form-label
        >
        <nz-form-control [nzSm]="14" [nzXs]="24">
          <input nz-input formControlName="dp" id="dp" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired nzFor="cut"
          >cut</nz-form-label
        >
        <nz-form-control [nzSm]="14" [nzXs]="24">
          <input nz-input formControlName="cut" id="cut" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired nzFor="source"
          >source</nz-form-label
        >
        <nz-form-control [nzSm]="14" [nzXs]="24">
          <input nz-input formControlName="source" id="source" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired nzFor="ticker"
          >ticker</nz-form-label
        >
        <nz-form-control [nzSm]="14" [nzXs]="24">
          <input nz-input formControlName="ticker" id="ticker" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired nzFor="currency"
          >currency</nz-form-label
        >
        <nz-form-control [nzSm]="14" [nzXs]="24">
          <input nz-input formControlName="currency" id="currency" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired nzFor="period"
          >period</nz-form-label
        >
        <nz-form-control [nzSm]="14" [nzXs]="24">
          <input nz-input formControlName="period" id="period" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired nzFor="growthType"
          >growthType</nz-form-label
        >
        <nz-form-control [nzSm]="14" [nzXs]="24">
          <input nz-input formControlName="growthType" id="growthType" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label
          [nzSm]="6"
          [nzXs]="24"
          nzRequired
          nzFor="historical_focus"
          >historical_focus</nz-form-label
        >
        <nz-form-control [nzSm]="14" [nzXs]="24">
          <input
            nz-input
            formControlName="historical_focus"
            id="historical_focus"
          />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired nzFor="original_cut"
          >original_cut</nz-form-label
        >
        <nz-form-control [nzSm]="14" [nzXs]="24">
          <input nz-input formControlName="original_cut" id="original_cut" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired nzFor="pg"
          >pg</nz-form-label
        >
        <nz-form-control [nzSm]="14" [nzXs]="24">
          <input nz-input formControlName="pg" id="pg" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired nzFor="param"
          >param</nz-form-label
        >
        <nz-form-control [nzSm]="14" [nzXs]="24">
          <input nz-input formControlName="param" id="param" />
        </nz-form-control>
      </nz-form-item>
      <!-- is_universalsliid needed for valuation page -->
      <nz-form-item>
        <nz-form-label
          [nzSm]="6"
          [nzXs]="24"
          nzRequired
          nzFor="is_universalsliid"
          >is_universalsliid</nz-form-label
        >
        <nz-form-control [nzSm]="14" [nzXs]="24">
          <input
            nz-input
            formControlName="is_universalsliid"
            id="is_universalsliid"
          />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired nzFor="tpr_page"
          >tpr_page</nz-form-label
        >
        <nz-form-control [nzSm]="14" [nzXs]="24">
          <input nz-input formControlName="tpr_page" id="tpr_page" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired nzFor="revision"
          >revision</nz-form-label
        >
        <nz-form-control [nzSm]="14" [nzXs]="24">
          <input nz-input formControlName="revision" id="revision" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired nzFor="incl_sources"
          >incl_sources</nz-form-label
        >
        <nz-form-control [nzSm]="14" [nzXs]="24">
          <input nz-input formControlName="incl_sources" id="incl_sources" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired nzFor="excl_sources"
          >excl_sources</nz-form-label
        >
        <nz-form-control [nzSm]="14" [nzXs]="24">
          <input nz-input formControlName="excl_sources" id="excl_sources" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired nzFor="extras"
          >extras</nz-form-label
        >
        <nz-form-control [nzSm]="14" [nzXs]="24">
          <input nz-input formControlName="extras" id="extras" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item nz-row class="register-area">
        <nz-form-control [nzSpan]="14" [nzOffset]="6">
          <button nz-button nzType="primary">Get formula</button>
        </nz-form-control>
      </nz-form-item>
    </form>
  </div>
  <button (click)="callForDummyData()">Load Dummy Data</button>

  <p>Old formula bar</p>
  <div id="old-formula-bar-container">
    <app-subheader-formulabar></app-subheader-formulabar>
  </div>
  <p>Page content</p>
  <div class="empty-div"></div>
  <p>New formula bar</p>
  <div id="new-formula-bar-container" *ngIf="load">
    <va-formula-bar
      [(dpCallObj)]="dpCallObj"
      apiUrl="/api/get_fb"
      [apiEP]="apiEP"
    ></va-formula-bar>
  </div>
  <p>Page content</p>
  <div class="empty-div"></div>
</div>
